import type { RoleName } from '../services/auth.service';

/** One entry of the main menu. */
export type MenuItem = {
  label: string;
  link: string;
  /** Also active on sub pages (e.g. /child/17 for "Kinder"). */
  exact?: boolean;
};

/**
 * Main menu per role. Bank and employment office run as kiosks operated by
 * children: they get no menu at all and can only use their one page.
 */
export const MENU: Record<RoleName, MenuItem[]> = {
  admin: [
    { label: 'Start', link: '/home/admin', exact: true },
    { label: 'Kinder', link: '/child' },
    { label: 'Jobs', link: '/job' },
    { label: 'Betreuer*innen', link: '/supervisor' },
    { label: 'Rathaus', link: '/town-hall' },
    { label: 'Einstellungen', link: '/settings' },
    { label: 'Wartung', link: '/maintenance' },
    { label: 'Handbuch', link: '/manual' },
  ],
  betreuer: [
    { label: 'Start', link: '/home/supervisor', exact: true },
    { label: 'Kinder', link: '/child' },
    { label: 'Jobs', link: '/job' },
    { label: 'Betreuer*innen', link: '/supervisor' },
    { label: 'Rathaus', link: '/town-hall' },
    { label: 'Handbuch', link: '/manual' },
  ],
  arbeitsamt: [],
  bank: [],
};

/** Kiosk roles: one page, no menu, no profile (operated by children). */
export const KIOSK_ROLES: readonly RoleName[] = ['arbeitsamt', 'bank'];

/** Name of the station shown in the header of a kiosk. */
export const KIOSK_TITLE: Partial<Record<RoleName, string>> = { arbeitsamt: 'Arbeitsamt', bank: 'Bank' };
